import { Reveal } from "./Reveal";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_balance-perfecto-pro/artifacts/7eokywln_nosotros.webp";

export const Nosotros = () => {
  return (
    <section
      id="nosotros"
      data-testid="nosotros-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-x-8 gap-y-16 items-start">
          <div className="col-span-12 lg:col-span-5 lg:sticky lg:top-32">
            <Reveal>
              <div className="flex items-center gap-3 text-[#017766] mb-8">
                <span className="h-px w-10 bg-[#017766]" />
                <span className="overline">Nosotros</span>
              </div>
            </Reveal>

            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl leading-[1.02] text-[#17351D] mb-10">
                Confianza, precisión y <em className="text-[#017766]">balance</em>{" "}
                en cada cifra.
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={ABOUT_IMG}
                  alt="Equipo profesional Lex Balance Perfecto"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-[#17351D]/10" />
              </div>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:col-start-7 space-y-10">
            <Reveal>
              <p className="font-display text-2xl md:text-3xl leading-snug text-[#17351D]">
                Somos una organización financiera consolidados en el ámbito de
                las auditorías a despachos y clientes particulares. Reconocidos
                por nuestro compromiso con la excelencia, la confidencialidad y
                la precisión en cada uno de los servicios que ofrecemos.
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <p className="text-base md:text-lg text-[#17351D]/70 leading-relaxed">
                En Lex Balance Perfecto nos enorgullecemos de estarnos convirtiendo
                en un referente confiable para bufetes jurídicos, notarías públicas
                y empresas que buscan soluciones efectivas en temas contables,
                fiscales y legales.
              </p>
            </Reveal>

            <Reveal delay={0.12}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-8 border-t border-[#17351D]/10">
                <article className="bg-[#F7F6F1] p-7 md:p-8 border-l-2 border-[#C1C82A]">
                  <div className="overline text-[#017766] mb-4">Misión</div>
                  <p className="text-[15px] text-[#17351D]/80 leading-relaxed">
                    Proveer soluciones de intermediación crediticia, inversión y
                    dispersión de fondos con la máxima solidez regulatoria,
                    facilitando el acceso al capital y optimizando los recursos
                    financieros de nuestros socios mediante esquemas de
                    financiamiento transparentes.
                  </p>
                </article>
                <article className="bg-[#17351D] p-7 md:p-8 border-l-2 border-[#C1C82A] text-white">
                  <div className="overline text-[#C1C82A] mb-4">Visión</div>
                  <p className="text-[15px] text-white/85 leading-relaxed">
                    Consolidarnos como el grupo integrador financiero no bursátil
                    de referencia en México; reconocidos por nuestra
                    diversificación en fondos de desarrollo, arrendamiento y
                    sociedades de inversión que marcan la pauta en rentabilidad y
                    certeza jurídica.
                  </p>
                </article>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="grid grid-cols-2 gap-6 pt-8 border-t border-[#17351D]/10">
                <Tile k="Sede" v="Zapopan, Jalisco" />
                <Tile k="Áreas" v="Legal · Contable · Fiscal" />
                <Tile k="Sector" v="Bufetes · Notarías · Empresas" />
                <Tile k="Filosofía" v="Orden y transparencia" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

const Tile = ({ k, v }) => (
  <div>
    <div className="text-[10px] tracking-[0.3em] uppercase text-[#017766] mb-2">
      {k}
    </div>
    <div className="font-display text-lg text-[#17351D]">{v}</div>
  </div>
);

export default Nosotros;
